import React from "react";

/**
 * [PONPISH] 위치기반서비스 이용약관 (React + TailwindCSS)
 * - Tailwind 설정이 된 환경을 전제로 작성합니다.
 * - 좌측 고정 목차(>=lg), 모바일 접이식 목차, 섹션 앵커 스크롤, 가독성 위주의 레이아웃 구성.
 */

const sections = [
  {
    id: "purpose",
    title: "1. 목적",
    body: (
      <p>
        본 약관은 회원(서비스 이용약관에 동의한 자)이 주식회사 챙기고(이하 “회사”)가 제공하는 위치기반서비스(이하 “서비스”)를 이용함에 있어 회사와 회원의 권리·의무 및 책임사항을 규정합니다.
      </p>
    ),
  },
  {
    id: "effect-change",
    title: "2. 약관의 효력 및 변경",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>회원이 본 약관에 동의하고 회사 절차에 따라 이용자로 등록하면 효력이 발생합니다.</li>
        <li>온라인에서 “동의하기”를 클릭하면 약관 내용을 충분히 이해하고 동의한 것으로 봅니다.</li>
        <li>회사는 약관을 서비스 초기화면에 게시하거나 기타 방법으로 공지합니다.</li>
        <li>
          회사는 약관을 변경할 수 있으며, 적용일 7일 전(회원에게 불리한 경우 30일 전)부터 개정내용·사유·적용일을 공지합니다.
        </li>
        <li>
          공지 시 거부 의사를 표시하지 않으면 동의한 것으로 보며, 동의하지 않는 경우 회원은 이용계약을 해지할 수 있습니다.
        </li>
      </ol>
    ),
  },
  {
    id: "outside-rules",
    title: "3. 약관 외 준칙",
    body: (
      <p>
        본 약관에 규정되지 않은 사항은 위치정보법, 전기통신사업법, 정보통신망법, 개인정보보호법 등 관련 법령과 회사 운영정책·세부지침, 개인정보 처리방침을 따릅니다.
      </p>
    ),
  },
  {
    id: "service-scope",
    title: "4. 서비스의 내용",
    body: (
      <ul className="list-disc pl-5 space-y-2">
        <li>회원 위치를 기준으로 가까운 안경원 정보 제공</li>
        <li>위치정보 수집대상의 실시간 위치 확인</li>
        <li>회원 위치에서 근접한 안경원 정보 추천</li>
      </ul>
    ),
  },
  {
    id: "fees",
    title: "5. 서비스의 이용 요금",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>기본 서비스는 무료입니다. 별도 유료 서비스는 해당 요금을 지불해야 합니다.</li>
        <li>유료 서비스 요금은 전자지불업체 또는 회사 청구 방식으로 청구될 수 있습니다.</li>
        <li>취소·환불은 결제 이용약관 및 관계법에 따릅니다.</li>
        <li>개인정보 도용/결제 사기 관련 환불 요청은 법률상 허용된 경우에만 처리됩니다.</li>
        <li>무선 데이터 통신료, MMS 요금 등은 통신사 정책을 따릅니다.</li>
      </ol>
    ),
  },
  {
    id: "retention",
    title: "6. 위치정보의 보유기간",
    body: (
      <p>
        개인위치정보의 수집·이용·제공 목적 달성 시 또는 동의 철회 시 지체 없이 파기합니다. 다만, 위치정보법 제16조 제2항에 따른 이용·제공 사실 확인자료는 법정 기간 동안 보존할 수 있습니다.
      </p>
    ),
  },
  {
    id: "notice-change",
    title: "7. 서비스내용변경 통지 등",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>서비스 내용 변경·종료 시 등록 이메일 등으로 통지할 수 있습니다.</li>
        <li>불특정 다수 통지의 경우 웹사이트 공지사항 등으로 갈음할 수 있습니다.</li>
      </ol>
    ),
  },
  {
    id: "limit-stop",
    title: "8. 서비스 이용의 제한 및 중지",
    body: (
      <div className="space-y-2">
        <p>다음 사유 발생 시 이용을 제한·중지할 수 있으며, 사유 및 기간을 통지합니다.</p>
        <ol className="list-decimal pl-5 space-y-1">
          <li>회원의 고의·중과실로 서비스 운영 방해</li>
          <li>설비 점검·보수·공사 등 불가피한 경우</li>
          <li>기간통신사업자 서비스 중지</li>
          <li>국가 비상사태·설비 장애·이용 폭주 등</li>
          <li>기타 중대한 사유로 제공이 부적당한 경우</li>
        </ol>
      </div>
    ),
  },
  {
    id: "rights",
    title: "9. 개인위치정보주체의 권리",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>언제든지 동의의 전부 또는 일부를 철회할 수 있으며, 회사는 관련 자료를 파기합니다.</li>
        <li>수집·이용·제공의 일시적 중지를 요구할 수 있으며, 회사는 이를 거절할 수 없습니다.</li>
        <li>
          다음 자료의 열람·고지·정정을 요구할 수 있으며, 회사는 정당한 사유 없이 거절할 수 없습니다.
          <ol className="list-decimal pl-5 mt-2 space-y-1">
            <li>본인에 대한 위치정보 수집·이용·제공 사실 확인자료</li>
            <li>법령에 의한 제3자 제공 사유 및 내용</li>
          </ol>
        </li>
      </ol>
    ),
  },
  {
    id: "use-provide",
    title: "10. 개인위치정보의 이용 또는 제공",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>서비스 제공을 위해서는 이용약관에 명시하고 개인위치정보주체의 동의를 받아야 합니다.</li>
        <li>분쟁 관할은 민사소송법 등 관련 법령에 따릅니다.</li>
      </ol>
    ),
  },
  {
    id: "under14",
    title: "11. 적용제외(만 14세 미만)",
    body: (
      <p>
        만 14세 미만은 회원가입 대상이 아니며, 회사는 해당 연령의 위치정보를 수집하지 않습니다. 관련 민원에 대한 책임을 지지 않습니다.
      </p>
    ),
  },
  {
    id: "thirdparty-limit",
    title: "12. 개인위치정보 제3자 제공 및 제한",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>회원 동의 없이 제3자에게 제공하지 않습니다. 제공 시 제공받는 자·목적을 사전 고지합니다.</li>
        <li>
          회원이 지정한 제3자 제공 시, 매회 제공받는 자·일시·목적을 당해 단말기로 즉시 통보합니다(예외 사유 시 사전 지정 주소로 통보).
        </li>
        <li>
          다음의 경우를 제외하고는 본 약관 또는 고지 범위를 넘어 이용·제공하지 않습니다.
          <ol className="list-decimal pl-5 mt-2 space-y-1">
            <li>요금 정산을 위해 확인자료가 필요한 경우</li>
            <li>통계·학술·시장조사 목적의 비식별 가공 제공</li>
          </ol>
        </li>
      </ol>
    ),
  },
  {
    id: "liability",
    title: "13. 손해배상",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>회사가 위치정보법 위반으로 손해 발생 시 고의·과실이 없음을 입증하지 못하면 배상 책임을 집니다.</li>
        <li>회원이 약관 위반으로 손해 발생 시 회원은 고의·과실이 없음을 입증하지 못하면 책임을 집니다.</li>
      </ol>
    ),
  },
  {
    id: "disclaimer",
    title: "14. 면책",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>천재지변 등 불가항력, 제휴사의 고의적 방해, 회원 귀책, 기타 회사의 고의·과실이 없는 경우 등에는 책임을 부담하지 않습니다.</li>
        <li>서비스 및 게재 정보의 신뢰도·정확성에 대한 보증을 하지 않으며, 이로 인한 손해에 책임을 지지 않습니다.</li>
      </ol>
    ),
  },
  {
    id: "governing",
    title: "15. 규정의 준용",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>본 약관은 대한민국 법령에 따라 규정·해석됩니다.</li>
        <li>약관에 정하지 않은 사항은 관련 법령 및 상관습을 따릅니다.</li>
      </ol>
    ),
  },
  {
    id: "dispute",
    title: "16. 분쟁의 조정 및 기타",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>방송통신위원회 재정 신청(위치정보법 제28조)에 따라 조정 신청이 가능합니다.</li>
        <li>개인정보분쟁조정위원회(개인정보보호법 제43조)에 조정 신청이 가능합니다.</li>
      </ol>
    ),
  },
  {
    id: "contact",
    title: "17. 회사의 연락처 및 위치정보관리책임자",
    body: (
      <div className="space-y-2">
        <div className="rounded-xl border p-4 bg-gray-50">
          <p className="font-medium">회사 정보</p>
          <ul className="list-disc pl-5 mt-2 space-y-1 text-sm">
            <li>상호: 주식회사 챙기고</li>
            <li>대표이사: 박태홍</li>
            <li>주소: 서울특별시 강남구 테헤란로 6길 33, 2층</li>
            <li>전화번호: 070-4271-0801</li>
            <li>이메일: contact@ponpish.kr</li>
          </ul>
        </div>
        <div className="rounded-xl border p-4 bg-gray-50">
          <p className="font-medium">위치정보관리 책임자</p>
          <ul className="list-disc pl-5 mt-2 space-y-1 text-sm">
            <li>성명: 홍승관</li>
            <li>직책: 본부장</li>
            <li>전화번호: 070-4271-0801</li>
            <li>이메일: privacy@ponpish.kr</li>
          </ul>
        </div>
      </div>
    ),
  },
];

function Toc({ sections }: { sections: { id: string; title: string }[] }) {
  return (
    <nav className="hidden lg:block sticky top-24 h-[calc(100vh-6rem)] overflow-auto pr-6">
      <h2 className="text-sm font-semibold text-black mb-3">목차</h2>
      <ol className="space-y-2 text-sm">
        {sections.map((s) => (
          <li key={s.id}>
            <a
              href={`#${s.id}`}
              className="block rounded-md px-2 py-1 hover:bg-gray-100 transition text-black"
            >
              {s.title}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}

function MobileToc({ sections }: { sections: { id: string; title: string }[] }) {
  return (
    <details className="lg:hidden mb-4 rounded-xl border bg-white shadow-sm">
      <summary className="cursor-pointer select-none px-4 py-3 text-sm font-medium text-black">목차 열기</summary>
      <div className="border-t px-4 py-3">
        <ol className="space-y-2 text-sm">
          {sections.map((s) => (
            <li key={s.id}>
              <a href={`#${s.id}`} className="block rounded-md px-2 py-1 hover:bg-gray-100 text-black">
                {s.title}
              </a>
            </li>
          ))}
        </ol>
      </div>
    </details>
  );
}

export default function PonpishLBS_TermsPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* 컨테이너 */}
      <main className="mx-auto max-w-6xl px-2 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-[260px,1fr] gap-8">
          <Toc sections={sections.map(({ id, title }) => ({ id, title }))} />

          <article className="min-w-0">
            <div className="rounded-2xl border bg-white p-6">
              <h1 className="text-2xl font-bold tracking-tight text-black">[PONPISH] 위치기반 서비스 이용약관</h1>
              <p className="mt-2 mb-4 text-sm text-gray-600">시행일: 2025년 8월 1일</p>

              <MobileToc sections={sections.map(({ id, title }) => ({ id, title }))} />

              <div className="divide-y">
                {sections.map((s) => (
                  <section id={s.id} key={s.id} className="scroll-mt-24 py-6">
                    <h2 className="text-lg font-semibold mb-3 text-black">{s.title}</h2>
                    <div className="space-y-3 leading-7 text-black">{s.body}</div>
                  </section>
                ))}
              </div>

              <footer className="mt-6 border-t pt-4 text-xs text-gray-600">
                법령·서비스 변경에 따라 본 문서는 갱신될 수 있습니다.
              </footer>
            </div>
          </article>
        </div>
      </main>
    </div>
  );
}
